import * as Yup from "yup";

export const CashMovementsSchema = Yup.object().shape({
  fecha: Yup.date().required("Campo obligatorio"),
});
